import { render, staticRenderFns } from "./VerVentaProcesada.vue?vue&type=template&id=5ff6d0c1"
import script from "./VerVentaProcesada.vue?vue&type=script&lang=js"
export * from "./VerVentaProcesada.vue?vue&type=script&lang=js"
import style0 from "./VerVentaProcesada.vue?vue&type=style&index=0&id=5ff6d0c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports